import { makeOperation } from 'urql';
import { pipe, tap } from 'wonka';

import type { Client, Exchange, Operation } from 'urql';

const activeQueriesByClient = new WeakMap<Client, Map<number, Operation>>();

export const activeQueriesExchange: Exchange = ({ client, forward }) => {
  const activeQueries = new Map<number, Operation>();
  activeQueriesByClient.set(client, activeQueries);

  return operations$ =>
    forward(
      pipe(
        operations$,
        tap(operation => {
          if (operation.kind === 'query') {
            activeQueries.set(operation.key, operation);
          } else if (operation.kind === 'teardown') {
            activeQueries.delete(operation.key);
          }
        }),
      ),
    );
};

// graphcache can only invalidate from an updater, so a user action refetches the queries on screen instead.
export const refetchActiveQueries = (client: Client, matches: (operation: Operation) => boolean) => {
  activeQueriesByClient.get(client)?.forEach(operation => {
    if (matches(operation)) {
      client.reexecuteOperation(
        makeOperation('query', operation, { ...operation.context, requestPolicy: 'network-only' }),
      );
    }
  });
};
